import { axios } from '@/utils/request'
// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import { isWebview } from './util'
import store from '@/store'
// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,

  // 你需要动态引入的页面组件
  mainManage: () => import('@/views/account/mainManage'),
  childManage: () => import('@/views/account/childManage'),
  basicConfig: () => import('@/views/account/basicConfig'),

  firstReview: () => import('@/views/audit/firstReview'),
  secondReview: () => import('@/views/audit/secondReview'),
  history: () => import('@/views/audit/history'),

  auditReview: () => import('@/views/audit/auditReview'),
  auditSReview: () => import('@/views/audit/auditSReview'),
  auditHistory: () => import('@/views/audit/auditHistory'),
  whiteList: () => import('@/views/listManage/whiteList'),
  blackList: () => import('@/views/listManage/blackList'),
  keyWords: () => import('@/views/listManage/keyWords'),
  blackListSync: () => import('@/views/blackListSync'),

  // auditcontList: () => import('@/views/auditcont/index'),
  // auditcontDetail: () => import('@/views/auditcont/detail'),

  marketList: () => import('@/views/markethelp/list'),
  marketDetail: () => import('@/views/markethelp/detail'),
  // 操作日志
  operationLog: () => import('@/views/system/operationLog')
  // ...more
}
const Layout = isWebview() ? 'BlankLayout' : 'BasicLayout' //侧边栏
const View =  isWebview() ? 'RouteView' : 'PageView' //顶部栏

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*',
  redirect: '/404',
  hidden: true
}

const system = {
  title: '系统管理',
  key: 'system',
  component: View,
  icon: 'desktop',
  children: [
    {
      title: '系统操作日志',
      key: 'operationLog'
    }
  ]
}

var quanxian = {
  title: '权限管理',
  key: 'permission',
  component: View,
  icon: 'user',
  children: [
    {
      title: '主账号管理',
      key: 'mainManage'
    },
    {
      title: '子账号管理',
      key: 'childManage'
    },
    {
      title: '基本配置',
      key: 'basicConfig'
    }
  ]
}

var quanxian1 = {
  title: '权限管理',
  key: 'permission',
  component: View,
  icon: 'user',
  children: [
    {
      title: '子账号管理',
      key: 'childManage'
    },
    {
      title: '基本配置',
      key: 'basicConfig'
    }
  ]
}

var reviews = {
  title: '审核管理',
  key: 'audit',
  component: View,
  icon: 'audit',
  children: [
    {
      title: '初审',
      key: 'firstReview'
    },
    {
      title: '复审',
      key: 'secondReview'
    },
    // {
    //   title: '历史消息',
    //   key: 'history'
    // }
  ]
}

var audit = {
  title: '质检管理',
  key: 'audit1',
  component: View,
  icon: 'file-protect',
  children: [
    {
      title: '初审',
      key: 'auditReview'
    },
    {
      title: '复审',
      key: 'auditSReview'
    },
    {
      title: '历史消息',
      key: 'auditHistory'
    }
  ]
}

var listm = {
  title: '名单管理',
  key: 'list',
  component: View,
  icon: 'user',
  children: [
    {
      title: '白名单',
      key: 'whiteList'
    },
    {
      title: '黑名单',
      key: 'blackList'
    },
    {
      title: '关键词',
      key: 'keyWords'
    }
  ]
}

var listm1 = {
  title: '名单管理',
  key: 'list',
  component: View,
  icon: 'solution',
  children: [
    {
      title: '黑名单',
      key: 'blackList'
    }
  ]
}
var listm2 = {
  title: '名单管理',
  key: 'list',
  component: View,
  icon: 'solution',
  children: [
    {
      title: '白名单',
      key: 'whiteList'
    },
    {
      title: '黑名单',
      key: 'blackList'
    },
    {
      title: '黑名单配置页',
      key: 'blackListSync'
    },
    {
      title: '关键词',
      key: 'keyWords'
    }
  ]
}

// var auditcont = {
//   title: '内容审核',
//   key: 'auditcont',
//   component: View,
//   icon: 'file-search',
//   children: [
//     {
//       title: '内容素材审核',
//       key: 'auditcontList'
//     },
//     {
//       title: '详情',
//       key: 'auditcontDetail',
//       hidden:true
//     },
//     {
//       title: '营销助手',
//       key: 'marketList'
//     },
//     {
//       title: '营销助手详情',
//       key: 'marketDetail',
//       hidden:true
//     },
//   ]
// }

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = () => {
  // return axios({
  //   url: '/admin/accesslist',
  //   method: 'get'
  //   /* headers: {
  //     'Access-Token': 'xxx'
  //   }
  //   */
  // })
  // return axios({
  //   url: '/admin/accesslist',
  //   method: 'get',
  //   headers: {
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   }
  // }).then(data=>{
  //   return {
  //
  //   }
  // })
  return new Promise(resolve => {

    if (store.getters.userInfo.role == 'ROLE_SYSTEM') {
      const arr = [system, quanxian, reviews]
      if (window.environment !== 'bz') {
        // arr.push(auditcont)
        arr.push(listm2)
        arr.push(audit)
      } else {
        arr.push(listm)
      }
      resolve({
        code: 1,
        message: '操作成功',
        result: [
          {
            title: '首页',
            key: '',
            name: 'index',
            component: Layout,
            redirect: '/permission/mainManage',
            children: arr
          }
        ]
      })
    } else if (store.getters.userInfo.role == 'ROLE_ADMIN') {
      const arr = [system,quanxian1, reviews, listm]
      // 临时添加上线删除
      // arr.push(auditcont)
      if (window.environment !== 'bz') {
        arr.push(audit)
      }
      resolve({
        code: 1,
        message: '操作成功',
        result: [
          {
            title: '首页',
            key: '',
            name: 'index',
            component: Layout,
            redirect: '/permission/childManage',
            children: arr
          }
        ]
      })
    } else if (store.getters.userInfo.role == 'ROLE_SUB') {
      // var arr = [listm,auditcont]
      var arr = [listm]
      if (store.getters.userInfo.access_audit == 1) {
        arr.push(reviews)
      }
      if (store.getters.userInfo.access_check == 1 && window.environment !== 'bz') {
        arr.push(audit)
      }
      resolve({
        code: 1,
        message: '操作成功',
        result: [
          {
            title: '首页',
            key: '',
            name: 'index',
            component: Layout,
            redirect: '/list/whiteList',
            children: arr
          }
        ]
      })
    } else if (store.getters.userInfo.role == 'ROLE_SUB_AUDIT') {
      // var arr = [listm1, reviews,auditcont]
      var arr = [listm1, reviews]
      if (window.environment !== 'bz') {
        arr.push(audit)
      }
      resolve({
        code: 1,
        message: '操作成功',
        result: [
          {
            title: '首页',
            key: '',
            name: 'index',
            component: Layout,
            redirect: '/audit/firstReview',
            children: arr
          }
        ]
      })
    }
  })
}

/**
 * 获取路由菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 *    @see https://github.com/sendya/ant-design-pro-vue/blob/feature/dynamic-menu/public/dynamic-menu.json
 * 2. 调用
 * @returns {Promise<any>}
 */
export const generatorDynamicRouter = data => {
  return new Promise((resolve, reject) => {
    // ajax
    getRouterByUser()
      .then(res => {
        const result = res.result
        const routers = generator(result)
        routers.push(notFoundRouter)
        resolve(routers)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    const currentRouter = {
      // 路由地址 动态拼接生成如 /dashboard/workplace
      path: `${(parent && parent.path) || ''}/${item.key}`,
      // 路由名称，建议唯一
      name: item.name || item.key || '',
      // 该路由对应页面的 组件
      component: constantRouterComponents[item.component || item.key],
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: { title: item.title, icon: item.icon || undefined, permission: (item.key && [item.key]) || null,hidden:!!item.hidden }
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    currentRouter.path = currentRouter.path.replace('//', '/')
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}
